<div class="container relative-container">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-10">
      <h2 class="h3 fw-bold text-primary mb-4 text-center f-24 f-lg-32 mt-4">
        Paso 2: Adjuntar soportes
      </h2>

      <p class="mb-5 px-lg-5 text-center f-16 f-lg-24">
        <span class="fw-bold"
          >A continuación, adjunta los documentos solicitados de manera
          legible</span
        >
        y completa, ya que esto puede influir en los tiempos de respuesta del
        reembolso. Te sugerimos revisar cada punto antes de cargar los archivos.
      </p>

      <div class="document-grid mt-4">
        <div class="document-wrapper">
          <div class="d-flex align-items-center document-item p-3">
            <div class="d-flex align-items-center flex-grow-1 me-3">
              <img
                class="pe-3"
                src="https://res.cloudinary.com/pervolare-org/image/upload/v1761265081/TAS/rutt/step2-support/ICON_Pasaporte_qixu9o.png"
                alt="icono pasaporte"
              />
              <div>
                <span
                  class="fw-bold d-block text-uppercase text-primary f-16 mb-1"
                  >Pasaporte/Otros</span
                >
                <p class="document-details mb-0" *ngIf="passport.length === 0">
                  Sube una imagen del pasaporte sellado donde se vean claramente
                  los datos de identificación.
                </p>
                <p
                  class="document-details fw-normal mb-0 text-title"
                  *ngIf="passport.length > 0"
                >
                  {{ passport.length }} Documentos subidos (Req. 2)
                </p>
              </div>
            </div>
            <button
              class="btn tas-btn-upload p-0"
              [ngClass]="{ success: isPassportValid() }"
              (click)="
                openModal(
                  'passport',
                  0,
                  'Pasaporte/Otros',
                  2,
                  'https://res.cloudinary.com/pervolare-org/image/upload/v1761265081/TAS/rutt/step2-support/ICON_Pasaporte_qixu9o.png'
                )
              "
            >
              <img
                *ngIf="!isPassportValid()"
                src="https://res.cloudinary.com/pervolare-org/image/upload/v1761257129/TAS/rutt/step2-support/arrow-up-white_xw546d.svg"
                alt="icon arrow"
              />
              <svg
                *ngIf="isPassportValid()"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </button>
          </div>
        </div>

        <ng-container *ngFor="let ctrl of expenseControls; let i = index">
          <div class="document-wrapper">
            <div class="d-flex align-items-center document-item p-3">
              <div class="d-flex align-items-center flex-grow-1 me-3">
                <img
                  class="pe-3"
                  src="https://res.cloudinary.com/pervolare-org/image/upload/v1761265067/TAS/rutt/step2-support/iocn-otros_w1aljc.png"
                  alt="icono factura"
                />
                <div>
                  <span
                    class="fw-bold d-block text-uppercase text-primary f-16 mb-1"
                    >Factura de Gastos / {{ getTypeExpense(i) }}</span
                  >
                  <p
                    class="document-details mb-0"
                    *ngIf="getExpensesFiles(i).length === 0"
                  >
                    Sube una imagen de cada factura correspondiente al gasto
                    reportado.
                  </p>
                  <p
                    class="document-details fw-normal mb-0 text-title"
                    *ngIf="getExpensesFiles(i).length > 0"
                  >
                    {{ getExpensesFiles(i).length }} Documentos subidos
                  </p>
                </div>
              </div>
              <button
                class="btn tas-btn-upload p-0"
                [ngClass]="{ success: isExpenseValid(i) }"
                (click)="
                  openModal(
                    'expense',
                    i,
                    'Factura de Gastos / ' + getTypeExpense(i),
                    3,
                    'https://res.cloudinary.com/pervolare-org/image/upload/v1761265067/TAS/rutt/step2-support/iocn-otros_w1aljc.png'
                  )
                "
              >
                <img
                  *ngIf="!isExpenseValid(i)"
                  src="https://res.cloudinary.com/pervolare-org/image/upload/v1761257129/TAS/rutt/step2-support/arrow-up-white_xw546d.svg"
                  alt="icon arrow"
                />
                <svg
                  *ngIf="isExpenseValid(i)"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </button>
            </div>
          </div>

          <div
            class="document-wrapper"
            *ngIf="isMedicineExpense(getTypeExpense(i))"
          >
            <div class="d-flex align-items-center document-item p-3">
              <div class="d-flex align-items-center flex-grow-1 me-3">
                <img
                  class="pe-3"
                  src="https://res.cloudinary.com/pervolare-org/image/upload/v1761265067/TAS/rutt/step2-support/iocn-otros_w1aljc.png"
                  alt="icono receta"
                />
                <div>
                  <span
                    class="fw-bold d-block text-uppercase text-primary f-16 mb-1"
                    >Receta Médica</span
                  >
                  <p
                    class="document-details mb-0"
                    *ngIf="getPrescriptionsFiles(i).length === 0"
                  >
                    Sube una imagen de la receta médica del beneficiario para el
                    medicamento reportado.
                  </p>
                  <p
                    class="document-details fw-normal mb-0 text-title"
                    *ngIf="getPrescriptionsFiles(i).length > 0"
                  >
                    {{ getPrescriptionsFiles(i).length }} Documentos subidos
                  </p>
                </div>
              </div>
              <button
                class="btn tas-btn-upload p-0"
                [ngClass]="{ success: isPrescriptionValid(i) }"
                (click)="
                  openModal(
                    'prescription',
                    i,
                    'Receta Médica',
                    3,
                    'https://res.cloudinary.com/pervolare-org/image/upload/v1761265067/TAS/rutt/step2-support/iocn-otros_w1aljc.png'
                  )
                "
              >
                <img
                  *ngIf="!isPrescriptionValid(i)"
                  src="https://res.cloudinary.com/pervolare-org/image/upload/v1761257129/TAS/rutt/step2-support/arrow-up-white_xw546d.svg"
                  alt="icon arrow"
                />
                <svg
                  *ngIf="isPrescriptionValid(i)"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </button>
            </div>
          </div>
        </ng-container>

        <div class="document-wrapper">
          <div class="d-flex align-items-center document-item p-3">
            <div class="d-flex align-items-center flex-grow-1 me-3">
              <img
                class="pe-3"
                [src]="
                  assistType === 'medical'
                    ? 'https://res.cloudinary.com/pervolare-org/image/upload/v1761265093/TAS/rutt/step2-support/ICON_Informe_medico_gzr2ij.png'
                    : 'https://res.cloudinary.com/pervolare-org/image/upload/v1761265067/TAS/rutt/step2-support/iocn-otros_w1aljc.png'
                "
                alt="icono soporte especial"
              />
              <div>
                <span
                  class="fw-bold d-block text-uppercase text-primary f-16 mb-1"
                >
                  {{ assistType === "medical" ? "Informe Médico" : "Soportes" }}
                </span>
                <p
                  class="document-details mb-0"
                  *ngIf="specialSupport.length === 0"
                >
                  {{
                    assistType === "medical"
                      ? "Sube el informe médico del beneficiario (si aplica)."
                      : "Carta o reclamo de la aerolínea, PIR para equipaje y denuncia policial para pérdida o robo de pasaporte."
                  }}
                </p>
                <p
                  class="document-details fw-normal mb-0 text-title"
                  *ngIf="specialSupport.length > 0"
                >
                  {{ specialSupport.length }} Documentos subidos
                </p>
              </div>
            </div>
            <button
              class="btn tas-btn-upload p-0"
              [ngClass]="{ success: isSpecialSupportValid() }"
              (click)="
                openModal(
                  'specialSupport',
                  0,
                  assistType === 'medical' ? 'Informe Médico' : 'Soportes',
                  3,
                  assistType === 'medical'
                    ? 'https://res.cloudinary.com/pervolare-org/image/upload/v1761265093/TAS/rutt/step2-support/ICON_Informe_medico_gzr2ij.png'
                    : 'https://res.cloudinary.com/pervolare-org/image/upload/v1761265067/TAS/rutt/step2-support/iocn-otros_w1aljc.png'
                )
              "
            >
              <img
                *ngIf="!isSpecialSupportValid()"
                src="https://res.cloudinary.com/pervolare-org/image/upload/v1761257129/TAS/rutt/step2-support/arrow-up-white_xw546d.svg"
                alt="icon arrow"
              />
              <svg
                *ngIf="isSpecialSupportValid()"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </button>
          </div>
        </div>

        <div class="document-wrapper">
          <div class="d-flex align-items-center document-item p-3">
            <div class="d-flex align-items-center flex-grow-1 me-3">
              <img
                class="pe-3"
                src="https://res.cloudinary.com/pervolare-org/image/upload/v1761265067/TAS/rutt/step2-support/iocn-otros_w1aljc.png"
                alt="icono otros"
              />
              <div>
                <span
                  class="fw-bold d-block text-uppercase text-primary f-16 mb-1"
                  >Otros Documentos</span
                >
                <p
                  class="document-details mb-0"
                  *ngIf="otherDocuments.length === 0"
                >
                  Adjunta cualquier documento adicional que respalde los gastos
                  reportados.
                </p>
                <p
                  class="document-details fw-normal mb-0 text-title"
                  *ngIf="otherDocuments.length > 0"
                >
                  {{ otherDocuments.length }} Documentos subidos
                </p>
              </div>
            </div>
            <button
              class="btn tas-btn-upload p-0"
              [ngClass]="{ success: isOtherValid() }"
              (click)="
                openModal(
                  'other',
                  0,
                  'Otros Documentos',
                  3,
                  'https://res.cloudinary.com/pervolare-org/image/upload/v1761265067/TAS/rutt/step2-support/iocn-otros_w1aljc.png'
                )
              "
            >
              <img
                *ngIf="!isOtherValid()"
                src="https://res.cloudinary.com/pervolare-org/image/upload/v1761257129/TAS/rutt/step2-support/arrow-up-white_xw546d.svg"
                alt="icon arrow"
              />
              <svg
                *ngIf="isOtherValid()"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div class="sk-circle" *ngIf="loading">
        <div
          class="spinner-border text-danger"
          role="status"
          style="width: 3rem; height: 3rem"
        >
          <span class="visually-hidden">Cargando...</span>
        </div>
      </div>

      <div class="my-5 pt-3 row justify-content-center m-0">
        <div class="col-12 col-md-auto px-0">
          <button
            class="btn btn-action w-100 d-flex justify-content-center align-items-center fw-bold"
            style="
              min-height: 54px;
              padding-left: 4rem;
              padding-right: 4rem;
              border-radius: 8px;
            "
            (click)="onSubmit()"
            [disabled]="loading"
          >
            <span *ngIf="!loading">Continuar</span>

            <ng-container *ngIf="loading">
              Cargando...
              <div
                class="spinner-border spinner-border-sm ms-2"
                role="status"
              ></div>
            </ng-container>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="tas-modal-overlay" *ngIf="modalData">
  <app-instruction-modal
    *ngIf="activeModalType === 'instructions'"
    [modalData]="modalData"
    [assistType]="assistType"
    (close)="closeModal()"
    (proceed)="proceedToUpload()"
  >
  </app-instruction-modal>

  <div
    class="tas-modal-content upload-modal"
    *ngIf="activeModalType === 'upload'"
  >
    <div class="d-flex align-items-center mb-4">
      <img
        [src]="modalData.icon"
        class="me-3"
        style="width: 40px; height: auto"
      />
      <div>
        <h5 class="fw-bold mb-1 text-uppercase f-16 f-md-18 text-primary">
          {{ modalData.title }}
        </h5>
        <span
          class="f-13 f-md-14 fw-normal d-block text-title"
          style="line-height: 1.25"
        >
          {{ getModalDescription() }}
        </span>
      </div>
    </div>

    <div class="files-list mb-4">
      <div
        class="file-row d-flex flex-column mb-3"
        *ngFor="let f of getActiveFiles()"
      >
        <span
          class="mb-1 f-14 f-md-16 text-primary"
          style="font-weight: normal"
        >
          {{ f.name }}
        </span>
        <button
          class="btn btn-sm d-inline-flex align-items-center justify-content-center bg-surface text-primary"
          style="max-width: max-content; border-radius: 4px; font-weight: 500"
          (click)="removeActiveFile(f)"
        >
          <span class="me-1" style="font-size: 16px; line-height: 1"
            >&times;</span
          >
          Eliminar
        </button>
      </div>
    </div>

    <div class="text-center mt-2">
      <input
        type="file"
        multiple
        #fileInput
        hidden
        (change)="onNativeFileSelect($event)"
        accept="image/jpeg,image/jpg,image/png,image/gif,application/pdf,application/zip,application/x-rar-compressed"
      />
      <button
        class="btn btn-action-primary-outline px-4 py-2 fw-bold"
        (click)="fileInput.click()"
      >
        Cargar más
      </button>

      <button
        class="btn btn-action ms-4 px-4 py-2 fw-bold"
        (click)="closeModal()"
      >
        Guardar
      </button>
    </div>

    <button class="tas-modal-close" (click)="closeModal()">&times;</button>
  </div>
</div>
